<template>
    <div id="report-overall">
        <div class="overall-content">
            <md-progress-bar md-mode="indeterminate" v-if="loading" />
            <div class="chart-container">
                <div class="chart-section">
                    <h2>Sessions Overall</h2>
                    <OverallChatCountChart title="Session Timeseries" :data="graphData" v-if="graphData" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.overall") }}</h2>
                    <OverallRatingChart title="Rating Timeseries" :data="graphData" v-if="graphData" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>Session Duration Overall</h2>
                    <OverallSessionDurationChart title="Chat Session Durations" :data="graphData" v-if="graphData" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import OverallChatCountChart from "./OverallChatCountChart.vue";
import OverallRatingChart from "./OverallRatingChart.vue";
import OverallSessionDurationChart from "./OverallSessionDurationChart.vue";

const log = log2("Overall");
export default {
    name: "Overall",
    components: {
        OverallChatCountChart,
        OverallRatingChart,
        OverallSessionDurationChart,
    },
    props: {
        graphData: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-overall {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                h2 {
                    text-align: center;
                    font-weight: 700;
                    font-size: 40px;
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
